<template>
    <div>
        <div class="vehicle-stock-container">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <h2 v-if="vehicle_stock_info">
                                    Update vehicle stock
                                </h2>
                                <h2 v-else>
                                    Create vehicle stock
                                </h2>
                            </div>
                            <template v-if="vehicleStockData.green_tree_sync_id && vehicleStockData.api_id">
                                <div class="col-md-6 text-right">
                                    <a v-if="$userIsAdmin()" @click="syncVehicleWithHewia()" class="link"
                                       target="_blank">Sync Heiwa Images</a>
                                    <img v-if="heiwaSyncLoading" src="/images/loading.svg" alt="Loading..."
                                         class="loader" width="16">
                                </div>
                            </template>
                        </div>
                        <form @submit.stop.prevent="onSubmit">
                            <messages :messages="messages" :scroll="true"/>
                            <div class="row">
                                <div class="col-md-12">
                                    <template v-if="vehicle_stock_info">
                                        <template v-if="vehicleStockData.green_tree_sync_id">
                                            <strong>Greentree Sync ID:</strong>
                                            {{ vehicleStockData.green_tree_sync_id }} |
                                        </template>
                                        <template v-if="vehicleStockData.api_id">
                                            <strong>Auc ID:</strong>
                                            <a :href="$laravelRoute('vehicle-detail', vehicleStockData.api_id)">
                                                {{ vehicleStockData.api_id }}
                                            </a> |
                                            <strong>Lot #:</strong> {{ vehicleStockData.lot }} |
                                        </template>
                                        <template v-if="vehicleStockData.auction_date">
                                            <strong>Auc Date</strong>
                                            {{ dateToMoment(vehicleStockData.auction_date, 'DD/MM/YYYY') }} |
                                        </template>
                                        <span title="This is the date to use in Green Tree import">
                                            <strong>Last updated:</strong>
                                            {{ dateToMoment(vehicleStockData.updated_at, 'DD/MM/YYYY') }} |
                                        </span>

                                        <strong>Date added:</strong>
                                        {{ dateToMoment(vehicleStockData.created_at, 'DD/MM/YYYY') }} |
                                        <template v-if="vehicleStockData.purchased_date">
                                            <strong>Purchased date: </strong>
                                            {{ dateToMoment(vehicleStockData.purchased_date, 'DD/MM/YYYY') }} |
                                        </template>
                                        <strong>Status: </strong>
                                        <template v-if="vehicleStockData.status === 1">
                                            GARAGE
                                        </template>
                                        <template v-else-if="vehicleStockData.status === 2">
                                            PURCHASED
                                        </template>
                                        <template v-else-if="vehicleStockData.status === 3">
                                            PUBLIC
                                        </template>
                                        <template v-else>
                                            UNSOLD
                                        </template>
                                        <br/>
                                        <template v-if="vehicleStockData.sold">
                                            <strong>Heiwa last checked: </strong>
                                            {{ dateToMoment(vehicleStockData.sold.json_checked_at, 'DD/MM/YYYY HH:MM') }} |
                                            <strong>Heiwa Last updated: </strong>
                                            {{ dateToMoment(vehicleStockData.sold.json_updated_at, 'DD/MM/YYYY HH:MM') }}
                                        </template>
                                    </template>
                                    <b-tabs class="info-tabs">
                                        <b-tab title="Data" active>
                                            <div class="row mt-3">
                                                <div class="col-md-6">
                                                    <div class="row">
                                                        <div class="col-md-12 mb-2">
                                                            <h3 @click="vehicle_details_open = !vehicle_details_open">
                                                                Vehicle Details
                                                                <i v-if="vehicle_details_open" class="fa fa-minus-square-o ml-1" aria-hidden="true"></i>
                                                                <i v-else class="fa fa-plus-square-o ml-1" aria-hidden="true"></i>
                                                            </h3>
                                                        </div>
                                                        <BCollapse v-model="vehicle_details_open" class="col-md-12">
                                                            <div class="horizontal-group">
                                                                <b-form-group label="Stock id"
                                                                              :label-for="getId('stock_id')"
                                                                              :state="fieldState('stock_id')"
                                                                              :invalid-feedback="invalidField('stock_id')"
                                                                              class="stockid-group"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('stock_id')"
                                                                        type="text"
                                                                        v-model="vehicleStockData.stock_id"
                                                                        :state="fieldState('stock_id')"
                                                                        placeholder="Enter stock id">
                                                                    </b-form-input>
                                                                    <div class="note">Alternative ID. Blank to use default.
                                                                    </div>
                                                                </b-form-group>
                                                                <b-form-group label="Chassis"
                                                                              :label-for="getId('chassis')"
                                                                              :state="fieldState('chassis')"
                                                                              :invalid-feedback="invalidField('chassis')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('chassis')"
                                                                        type="text"
                                                                        v-model="vehicleStockData.chassis"
                                                                        :state="fieldState('chassis')"
                                                                        placeholder="Enter chassis type">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <b-form-group label="CO2 Emissions"
                                                                              :label-for="getId('co2_emissions')"
                                                                              :state="fieldState('co2_emissions')"
                                                                              :invalid-feedback="invalidField('co2_emissions')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('co2_emissions')"
                                                                        type="number"
                                                                        v-model="vehicleStockData.co2_emissions"
                                                                        :state="fieldState('co2_emissions')"
                                                                        placeholder="Enter CO2 emissions">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <b-form-group label="Make"
                                                                              :label-for="getId('make')"
                                                                              :state="fieldState('make')"
                                                                              :invalid-feedback="invalidField('make')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('make')"
                                                                        type="text"
                                                                        v-model="vehicleStockData.make"
                                                                        :state="fieldState('make')"
                                                                        placeholder="Enter make">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <b-form-group label="Model"
                                                                              :label-for="getId('model')"
                                                                              :state="fieldState('model')"
                                                                              :invalid-feedback="invalidField('model')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('model')"
                                                                        type="text"
                                                                        maxlength="30"
                                                                        v-model="vehicleStockData.model"
                                                                        :state="fieldState('model')"
                                                                        placeholder="Enter model">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <b-form-group label="Grade"
                                                                              :label-for="getId('grade')"
                                                                              :state="fieldState('grade')"
                                                                              :invalid-feedback="invalidField('grade')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('grade')"
                                                                        type="text"
                                                                        maxlength="30"
                                                                        v-model="vehicleStockData.grade"
                                                                        :state="fieldState('grade')"
                                                                        placeholder="Enter grade">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Year"
                                                                                      :label-for="getId('year')"
                                                                                      :state="fieldState('year')"
                                                                                      :invalid-feedback="invalidField('year')"
                                                                        >
                                                                            <b-form-input
                                                                                :id="getId('year')"
                                                                                type="number"
                                                                                v-model="vehicleStockData.year"
                                                                                :state="fieldState('year')"
                                                                                placeholder="Enter year">
                                                                            </b-form-input>
                                                                        </b-form-group>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Mileage"
                                                                                      :label-for="getId('mileage')"
                                                                                      :state="fieldState('mileage')"
                                                                                      :invalid-feedback="invalidField('mileage')"
                                                                        >
                                                                            <b-form-input
                                                                                :id="getId('mileage')"
                                                                                type="number"
                                                                                v-model="vehicleStockData.mileage"
                                                                                :state="fieldState('mileage')"
                                                                                placeholder="Enter mileage">
                                                                            </b-form-input>
                                                                        </b-form-group>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Engine CC"
                                                                                      :label-for="getId('engine_capacity')"
                                                                                      :state="fieldState('engine_capacity')"
                                                                                      :invalid-feedback="invalidField('engine_capacity')"
                                                                        >
                                                                            <b-form-input
                                                                                :id="getId('engine_capacity')"
                                                                                type="number"
                                                                                v-model="vehicleStockData.engine_capacity"
                                                                                :state="fieldState('engine_capacity')"
                                                                                placeholder="Enter engine capacity">
                                                                            </b-form-input>
                                                                        </b-form-group>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Trans."
                                                                                      :label-for="getId('transmission')"
                                                                                      :state="fieldState('transmission')"
                                                                                      :invalid-feedback="invalidField('transmission')"
                                                                        >
                                                                            <b-form-select
                                                                                :id="getId('transmission')"
                                                                                :options="transmissionOptions"
                                                                                class="form-control"
                                                                                type="text"
                                                                                v-model="vehicleStockData.transmission"
                                                                                :state="fieldState('transmission')"
                                                                                placeholder="Enter transmission">
                                                                            </b-form-select>
                                                                        </b-form-group>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Fuel type"
                                                                                      :label-for="getId('fuel_type')"
                                                                                      :state="fieldState('fuel_type')"
                                                                                      :invalid-feedback="invalidField('fuel_type')"
                                                                        >
                                                                            <b-form-select
                                                                                class="form-control"
                                                                                v-model="vehicleStockData.fuel_type"
                                                                                :options="fuelTypeOptions"
                                                                                :id="getId('fuel_type')"
                                                                            ></b-form-select>
                                                                        </b-form-group>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Doors"
                                                                                      :label-for="getId('doors')"
                                                                                      :state="fieldState('doors')"
                                                                                      :invalid-feedback="invalidField('doors')"
                                                                        >
                                                                            <b-form-input
                                                                                :id="getId('doors')"
                                                                                type="number"
                                                                                v-model="vehicleStockData.doors"
                                                                                :state="fieldState('doors')"
                                                                                placeholder="Enter doors">
                                                                            </b-form-input>
                                                                        </b-form-group>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Color"
                                                                                      :label-for="getId('color')"
                                                                                      :state="fieldState('color')"
                                                                                      :invalid-feedback="invalidField('color')"
                                                                        >
                                                                            <b-form-input
                                                                                :id="getId('color')"
                                                                                type="text"
                                                                                v-model="vehicleStockData.color"
                                                                                :state="fieldState('color')"
                                                                                placeholder="Enter color">
                                                                            </b-form-input>
                                                                        </b-form-group>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <b-form-group label="Condition"
                                                                                      :label-for="getId('condition')"
                                                                                      :state="fieldState('condition')"
                                                                                      :invalid-feedback="invalidField('condition')"
                                                                        >
                                                                            <b-form-input
                                                                                :id="getId('condition')"
                                                                                type="number"
                                                                                step="0.5"
                                                                                v-model="vehicleStockData.condition"
                                                                                :state="fieldState('condition')"
                                                                                placeholder="Enter condition">
                                                                            </b-form-input>
                                                                        </b-form-group>
                                                                    </div>
                                                                </div>
                                                                <b-form-group label="Ac"
                                                                              :label-for="getId('ac')"
                                                                              :state="fieldState('ac')"
                                                                              :invalid-feedback="invalidField('ac')"
                                                                >
                                                                    <b-form-select
                                                                        :id="getId('ac')"
                                                                        :options="acOptions"
                                                                        class="form-control"
                                                                        type="text"
                                                                        v-model="vehicleStockData.ac"
                                                                        :state="fieldState('ac')"
                                                                        placeholder="Enter ac">
                                                                    </b-form-select>
                                                                </b-form-group>
                                                            </div>
                                                        </BCollapse>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label :for="getId('equipment')">
                                                                    Equipment
                                                                </label>
                                                                <b-form-input
                                                                    style="width:100%"
                                                                    :id="getId('equipment')"
                                                                    :state="fieldState('equipment')"
                                                                    v-model="vehicleStockData.equipment"
                                                                ></b-form-input>
                                                                <b-form-invalid-feedback
                                                                    :state="fieldState('equipment')">
                                                                    {{ invalidField('equipment') }}
                                                                </b-form-invalid-feedback>
                                                            </div>
                                                            <div class="form-group">
                                                                <label>
                                                                    Sales note
                                                                    <small>
                                                                        shown on vehicle list page in large image view
                                                                    </small>
                                                                </label>
                                                                <b-form-textarea
                                                                    style="width:100%"
                                                                    :id="getId('sales_note')"
                                                                    :state="fieldState('sales_note')"
                                                                    v-model="vehicleStockData.sales_note"
                                                                ></b-form-textarea>
                                                                <b-form-invalid-feedback
                                                                    :state="fieldState('sales_note')">
                                                                    {{ invalidField('sales_note') }}
                                                                </b-form-invalid-feedback>
                                                            </div>


                                                            <div class="form-group">
                                                                <label>
                                                                    Auction note
                                                                    <small>
                                                                        shows on the vehicle detail page
                                                                    </small>
                                                                </label>
                                                                <b-form-textarea
                                                                    style="width:100%"
                                                                    :id="getId('auction_note')"
                                                                    :state="fieldState('auction_note')"
                                                                    v-model="vehicleStockData.auction_note"
                                                                ></b-form-textarea>
                                                                <b-form-invalid-feedback
                                                                    :state="fieldState('auction_note')">
                                                                    {{ invalidField('auction_note') }}
                                                                </b-form-invalid-feedback>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="horizontal-group">
                                                        <h3>Images</h3>
                                                        <template v-if="vehicleStockData.id">
                                                            <div>
                                                                <div class="form-row">
                                                                    <b-form-group class="vehicle-image"
                                                                                  label="Sheet"
                                                                                  :label-for="getId('sheet_image')"
                                                                                  :state="fieldState('sheet_image')"
                                                                                  :invalid-feedback="invalidField('sheet_image')"
                                                                    >
                                                                        <div class="image">
                                                                            <el-image
                                                                                v-if="vehicleStockData.sheet_image_url"
                                                                                :src="vehicleStockData.sheet_image_url"
                                                                                :preview-src-list="[vehicleStockData.sheet_image_url]"
                                                                                alt="Sheet image">
                                                                            </el-image>
                                                                            <span v-else>No image</span>
                                                                        </div>
                                                                        <b-form-file
                                                                            :state="null"
                                                                            :id="getId('sheet_image')"
                                                                            v-model="vehicleStockData.sheet_image"
                                                                            placeholder="Choose a file or drop it here..."
                                                                            drop-placeholder="Drop file here..."
                                                                            class="mt-3"
                                                                            ref="sheet"
                                                                            @input="imageUpload('sheet')"
                                                                        ></b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <template slot="same">
                                                                    <a href="#!"
                                                                       @click.prevent="copyImage('sheet', soldData.sheetimage)"
                                                                       title="Copy" class="verticle">
                                                                        Copy
                                                                    </a>
                                                                </template>
                                                                <template slot="to">
                                                                    <div style="width: 500px;">
                                                                        <el-image
                                                                            v-if="soldData.sheetimage"
                                                                            :src="soldData.sheetimage"
                                                                            :preview-src-list="[soldData.sheetimage]"
                                                                            alt="Sheet image">
                                                                        </el-image>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div>
                                                                <div class="form-row">
                                                                    <b-form-group class="vehicle-image"
                                                                                  label="Front"
                                                                                  :label-for="getId('front_image')"
                                                                                  :state="fieldState('front_image')"
                                                                                  :invalid-feedback="invalidField('front_image')"
                                                                    >
                                                                        <div class="image">
                                                                            <el-image
                                                                                v-if="vehicleStockData.front_image_url"
                                                                                :src="vehicleStockData.front_image_url"
                                                                                :preview-src-list="[vehicleStockData.front_image_url]"
                                                                                alt="Front image">
                                                                            </el-image>
                                                                            <span v-else>No image</span>
                                                                        </div>
                                                                        <b-form-file
                                                                            :state="null"
                                                                            :id="getId('front_image')"
                                                                            v-model="vehicleStockData.front_image"
                                                                            placeholder="Choose a file or drop it here..."
                                                                            drop-placeholder="Drop file here..."
                                                                            class="mt-3"
                                                                            ref="front"
                                                                            @input="imageUpload('front')"
                                                                        ></b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <template slot="same">
                                                                    <a href="#!"
                                                                       @click.prevent="copyImage('front', soldData.frontimage)"
                                                                       title="Copy" class="verticle">
                                                                        Copy
                                                                    </a>
                                                                </template>
                                                                <template slot="to">
                                                                    <div style="width: 500px;">
                                                                        <el-image
                                                                            v-if="soldData.frontimage"
                                                                            :src="soldData.frontimage"
                                                                            :preview-src-list="[soldData.frontimage]"
                                                                            alt="Sheet image">
                                                                        </el-image>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div>
                                                                <div class="form-row">
                                                                    <b-form-group class="vehicle-image"
                                                                                  label="Back"
                                                                                  :label-for="getId('back_image')"
                                                                                  :state="fieldState('back_image')"
                                                                                  :invalid-feedback="invalidField('back_image')"
                                                                    >
                                                                        <div class="image">
                                                                            <el-image
                                                                                v-if="vehicleStockData.back_image_url"
                                                                                :src="vehicleStockData.back_image_url"
                                                                                :preview-src-list="[vehicleStockData.back_image_url]"
                                                                                alt="Back image">
                                                                            </el-image>
                                                                            <span v-else>No image</span>
                                                                        </div>
                                                                        <b-form-file
                                                                            :state="null"
                                                                            :id="getId('back_image')"
                                                                            v-model="vehicleStockData.back_image"
                                                                            placeholder="Choose a file or drop it here..."
                                                                            drop-placeholder="Drop file here..."
                                                                            class="mt-3"
                                                                            ref="back"
                                                                            @input="imageUpload('back')"
                                                                        ></b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <template slot="same">
                                                                    <a href="#!"
                                                                       @click.prevent="copyImage('back', soldData.backimage)"
                                                                       title="Copy" class="verticle">
                                                                        Copy
                                                                    </a>
                                                                </template>
                                                                <template slot="to">
                                                                    <div style="width: 500px;">
                                                                        <el-image
                                                                            v-if="soldData.backimage"
                                                                            :src="soldData.backimage"
                                                                            :preview-src-list="[soldData.backimage]"
                                                                            alt="Back image">
                                                                        </el-image>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div>
                                                                <div class="form-row">
                                                                    <b-form-group class="vehicle-image"
                                                                                  label="Inside"
                                                                                  :label-for="getId('inside_image')"
                                                                                  :state="fieldState('inside_image')"
                                                                                  :invalid-feedback="invalidField('inside_image')"
                                                                    >
                                                                        <div class="image">
                                                                            <el-image
                                                                                v-if="vehicleStockData.inside_image_url"
                                                                                :src="vehicleStockData.inside_image_url"
                                                                                :preview-src-list="[vehicleStockData.inside_image_url]"
                                                                                alt="Inside image">
                                                                            </el-image>
                                                                            <span v-else>No image</span>
                                                                        </div>
                                                                        <b-form-file
                                                                            :state="null"
                                                                            :id="getId('inside_image')"
                                                                            v-model="vehicleStockData.inside_image"
                                                                            placeholder="Choose a file or drop it here..."
                                                                            drop-placeholder="Drop file here..."
                                                                            class="mt-3"
                                                                            ref="inside"
                                                                            @input="imageUpload('inside')"
                                                                        ></b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <template slot="same">
                                                                    <a href="#!"
                                                                       @click.prevent="copyImage('inside', soldData.insideimage)"
                                                                       title="Copy" class="verticle">
                                                                        Copy
                                                                    </a>
                                                                </template>
                                                                <template slot="to">
                                                                    <div style="width: 500px;">
                                                                        <el-image
                                                                            v-if="soldData.insideimage"
                                                                            :src="soldData.insideimage"
                                                                            :preview-src-list="[soldData.insideimage]"
                                                                            alt="Back image">
                                                                        </el-image>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            You can add images after saving
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="row">
                                                        <div class="col-md-12 mb-2">
                                                            <h3 @click="purchase_admin_open = !purchase_admin_open">
                                                                Purchase Admin
                                                                <i v-if="purchase_admin_open" class="fa fa-minus-square-o ml-1" aria-hidden="true"></i>
                                                                <i v-else class="fa fa-plus-square-o ml-1" aria-hidden="true"></i>
                                                            </h3>
                                                        </div>

                                                        <BCollapse v-model="purchase_admin_open" class="col-md-12">
                                                            <div class="row horizontal-group">
                                                                <div class="col-md-6">
                                                                    <b-form-group v-if="$userIsSuperAdmin()"
                                                                                  label="Status"
                                                                                  :label-for="getId('status')"
                                                                                  :state="fieldState('status')"
                                                                                  :invalid-feedback="invalidField('status')"
                                                                    >
                                                                        <b-form-select
                                                                            :id="getId('status')"
                                                                            :options="statusOptions"
                                                                            class="form-control"
                                                                            v-model="vehicleStockData.status"
                                                                            :state="fieldState('status')"
                                                                            @change="onStatusChange"
                                                                            placeholder="Enter status">
                                                                        </b-form-select>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <b-form-group v-show="vehicleStockData.status === 4"
                                                                                  label="Unsold Rep"
                                                                                  :label-for="getId('unsold_rep_id')"
                                                                                  :state="fieldState('unsold_rep_id')"
                                                                                  :invalid-feedback="invalidField('unsold_rep_id')">
                                                                        <user-selector
                                                                            v-model="vehicleStockData.unsold_rep_id"
                                                                            placeholder="-"
                                                                            :allow-empty="true"
                                                                            :names-first="true"
                                                                            :include-me="false"
                                                                            :include-dealers="false"
                                                                            :include-admins="true"
                                                                            :admins-include-super-admin="true"
                                                                            :filter-users-function="filterUnsoldReps"
                                                                        >
                                                                        </user-selector>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>
                                                            <div class="horizontal-group">
                                                                <b-form-group
                                                                    v-if="!vehicle_stock_info"
                                                                    label="Purchased date"
                                                                    :label-for="getId('purchased_date')"
                                                                    :state="fieldState('purchased_date')"
                                                                    :invalid-feedback="invalidField('purchased_date')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('purchased_date')"
                                                                        type="date"
                                                                        v-model="vehicleStockData.purchased_date"
                                                                        :state="fieldState('purchased_date')"
                                                                        placeholder="Enter purchased date">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="row horizontal-group">
                                                                <div class="col-md-6">
                                                                    <b-form-group
                                                                        label="User"
                                                                        :label-for="getId('user_id')"
                                                                        :state="fieldState('user_id')"
                                                                        :invalid-feedback="invalidField('user_id')">
                                                                        <user-selector
                                                                            v-model="vehicleStockData.user_id"
                                                                            @change="onUserChange"
                                                                            placeholder="-"
                                                                            :allow-empty="true"
                                                                            :names-first="true"
                                                                        >
                                                                        </user-selector>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <b-form-group label="Sold date"
                                                                                  :label-for="getId('sold_date')"
                                                                                  :state="fieldState('sold_date')"
                                                                                  :invalid-feedback="invalidField('sold_date')"
                                                                    >
                                                                        <b-form-input
                                                                            :id="getId('sold_date')"
                                                                            type="date"
                                                                            v-model="vehicleStockData.sold_date"
                                                                            :state="fieldState('sold_date')"
                                                                            placeholder="Enter sold date">
                                                                        </b-form-input>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>
                                                            <div class="row horizontal-group large-labels">
                                                                <div class="col-md-6">
                                                                    <b-form-group
                                                                        label="Currency"
                                                                        :label-for="getId('currency')"
                                                                        :state="fieldState('currency')"
                                                                        :invalid-feedback="invalidField('currency')"
                                                                    >
                                                                        <b-form-select
                                                                            :id="getId('currency')"
                                                                            :options="currencyOptions"
                                                                            class="form-control"
                                                                            v-model="vehicleStockData.currency"
                                                                            :state="fieldState('currency')"
                                                                            placeholder="Currency">
                                                                        </b-form-select>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <b-form-group
                                                                        label="Final price"
                                                                        :label-for="getId('sold_price')"
                                                                        :state="fieldState('sold_price')"
                                                                        :invalid-feedback="invalidField('sold_price')"
                                                                    >
                                                                        <b-form-input
                                                                            :id="getId('sold_price')"
                                                                            type="number"
                                                                            :disabled="!canEditSoldPrice()"
                                                                            v-model="vehicleStockData.sold_price"
                                                                            :state="fieldState('sold_price')"
                                                                            placeholder="Enter final date">
                                                                        </b-form-input>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>
                                                            <div class="row horizontal-group">
                                                                <b-form-group class="col-md-6"
                                                                              label="Ship"
                                                                              :label-for="getId('ship')"
                                                                              :state="fieldState('ship')"
                                                                              :invalid-feedback="invalidField('ship')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('ship')"
                                                                        type="text"
                                                                        v-model="vehicleStockData.ship"
                                                                        :state="fieldState('ship')"
                                                                        placeholder="Ship">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <b-form-group class="col-md-6"
                                                                              label="Port"
                                                                              :label-for="getId('port')"
                                                                              :state="fieldState('port')"
                                                                              :invalid-feedback="invalidField('port')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('port')"
                                                                        type="text"
                                                                        v-model="vehicleStockData.port"
                                                                        :state="fieldState('port')"
                                                                        placeholder="Port">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="row horizontal-group">
                                                                <b-form-group class="col-md-6"
                                                                              label="ETD"
                                                                              :label-for="getId('estimated_departure_date')"
                                                                              :state="fieldState('estimated_departure_date')"
                                                                              :invalid-feedback="invalidField('estimated_departure_date')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('estimated_departure_date')"
                                                                        type="date"
                                                                        v-model="vehicleStockData.estimated_departure_date"
                                                                        :state="fieldState('estimated_departure_date')"
                                                                        placeholder="Enter estimated departure date">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <b-form-group class="col-md-6"
                                                                              label="ETA"
                                                                              :label-for="getId('estimated_arrival_date')"
                                                                              :state="fieldState('estimated_arrival_date')"
                                                                              :invalid-feedback="invalidField('estimated_arrival_date')"
                                                                >
                                                                    <b-form-input
                                                                        :id="getId('estimated_arrival_date')"
                                                                        type="date"
                                                                        v-model="vehicleStockData.estimated_arrival_date"
                                                                        :state="fieldState('estimated_arrival_date')"
                                                                        placeholder="Enter estimated arrival date">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="form-group">
                                                                <label>Staff note <small>only
                                                                    admins can see this note</small></label>
                                                                <b-form-textarea
                                                                    style="width:100%"
                                                                    :id="getId('staff_note')"
                                                                    :state="fieldState('staff_note')"
                                                                    v-model="vehicleStockData.staff_note"
                                                                ></b-form-textarea>
                                                                <b-form-invalid-feedback
                                                                    :state="fieldState('staff_note')">
                                                                    {{ invalidField('staff_note') }}
                                                                </b-form-invalid-feedback>
                                                            </div>
                                                            <div v-if="$userIsAdmin()" class="form-group">
                                                                <label>Rep note <small>Doesn't show anywhere except here, this is for the rep to store notes about the vehicle</small></label>
                                                                <b-form-textarea
                                                                    style="width:100%" :id="getId('rep_note')"
                                                                    :state="fieldState('rep_note')"
                                                                    v-model="vehicleStockData.rep_note"
                                                                ></b-form-textarea>
                                                                <b-form-invalid-feedback
                                                                    :state="fieldState('rep_note')">
                                                                    {{ invalidField('rep_note') }}
                                                                </b-form-invalid-feedback>
                                                            </div>
                                                        </BCollapse>
                                                    </div>

                                                    <div class="row horizontal-group">
                                                        <div class="col-md-12 mb-2">
                                                            <h3 @click="stock_list_open = !stock_list_open">
                                                                Stocklist
                                                                <i v-if="stock_list_open" class="fa fa-minus-square-o ml-1" aria-hidden="true"></i>
                                                                <i v-else class="fa fa-plus-square-o ml-1" aria-hidden="true"></i>
                                                            </h3>
                                                        </div>
                                                        <BCollapse v-model="stock_list_open" class="col-md-12">
                                                            <!-- they wanted to remove this https://publica.scoro.com/tasks/view/39073 -->
                                                            <!-- <b-form-group
                                                                label="Sale tag"
                                                                :label-for="getId('sale_tag')"
                                                                :state="fieldState('sale_tag')"
                                                                :invalid-feedback="invalidField('sale_tag')"
                                                            >
                                                                <b-form-select
                                                                    :id="getId('sale_tag')"
                                                                    :options="saleTagOptions"
                                                                    class="form-control"
                                                                    v-model="vehicleStockData.sale_tag"
                                                                    :state="fieldState('sale_tag')"
                                                                    placeholder="Sale_tag">
                                                                </b-form-select>
                                                            </b-form-group> -->
                                                            <b-form-group
                                                                label="Public Date"
                                                                :label-for="getId('public_date')"
                                                                :state="fieldState('public_date')"
                                                                :invalid-feedback="invalidField('public_date')"
                                                            >
                                                                <b-form-input
                                                                    :id="getId('public_date')"
                                                                    type="date"
                                                                    v-model="vehicleStockData.public_date"
                                                                    :state="fieldState('public_date')" />
                                                            </b-form-group>
                                                            <div v-if="$userIsSuperAdmin()" class="checkbox-group">
                                                                <b-form-group
                                                                    label="Buy Now"
                                                                    :label-for="getId('buy_now')"
                                                                    :state="fieldState('buy_now')"
                                                                    :invalid-feedback="invalidField('buy_now')"
                                                                >
                                                                    <b-form-checkbox
                                                                        v-model="vehicleStockData.buy_now"
                                                                        id="buy_now" value="1">
                                                                    </b-form-checkbox>
                                                                </b-form-group>
                                                                <b-form-group
                                                                    label="Add to Auto Mailer"
                                                                    label-class="auto-mailer-label"
                                                                    :label-for="getId('add_to_auto_mailer')"
                                                                    :state="fieldState('add_to_auto_mailer')"
                                                                    :invalid-feedback="invalidField('add_to_auto_mailer')"
                                                                >
                                                                    <b-form-checkbox v-model="vehicleStockData.add_to_auto_mailer" id="add_to_auto_mailer" value="1">
                                                                    </b-form-checkbox>
                                                                </b-form-group>
                                                                <b-form-group
                                                                    label="Auto Price Reduction"
                                                                    label-class="auto-reduction-label"
                                                                    :label-for="getId('enable_auto_price_reduction')"
                                                                    :state="fieldState('enable_auto_price_reduction')"
                                                                    :invalid-feedback="invalidField('enable_auto_price_reduction')"
                                                                >
                                                                    <b-form-checkbox v-model="vehicleStockData.enable_auto_price_reduction" id="enable_auto_price_reduction" value="1">
                                                                    </b-form-checkbox>
                                                                </b-form-group>

                                                                <b-form-group
                                                                    v-if="vehicleStockData.enable_auto_price_reduction"
                                                                    label="Price Reduction"
                                                                    label-class="auto-reduction-label"
                                                                    :label-for="getId('auto_reduction_price')"
                                                                    :state="fieldState('auto_reduction_price')"
                                                                    :invalid-feedback="invalidField('auto_reduction_price')"
                                                                >
                                                                    <b-form-input
                                                                        :disabled="!$userIsSuperAdmin()"
                                                                        type="number"
                                                                        v-model="vehicleStockData.auto_reduction_price"
                                                                        placeholder="Default $500">
                                                                    </b-form-input>
                                                                </b-form-group>
                                                                <b-form-group v-if="nextReductionDate"
                                                                    label="Next Reduction Date"
                                                                     :label-for="getId('nextReductionDate')"
                                                                >
                                                                    <b-form-input
                                                                        type="text"
                                                                        v-model="nextReductionDate"
                                                                        :disabled="true"
                                                                    />
                                                                </b-form-group>
                                                            </div>
                                                            <div class="mt-3">
                                                                <h3 style="display: inline-block">
                                                                    Stock Pricing -
                                                                </h3>
                                                                <a class="pricing-link" href="#!" @click.prevent="show_all_regions = !show_all_regions">
                                                                    <template v-if="show_all_regions">
                                                                        Hide extra regions
                                                                    </template>
                                                                    <template v-else>
                                                                        Show all regions
                                                                    </template>
                                                                </a>
                                                            </div>
                                                            <b-table id="pricing-table" :items="regions_show"
                                                                     :fields="[{label: 'Stock list', key: 'enable'}, 'name', 'price', 'reduction_price','currency']">
                                                                <template v-slot:cell(enable)="data">
                                                                    <b-form-checkbox
                                                                        v-model="regionsData[data.item.id].is_active"
                                                                        :disabled="!$userIsSuperAdmin()"
                                                                    >
                                                                    </b-form-checkbox>
                                                                </template>
                                                                <template v-slot:cell(name)="data">
                                                                        <span :title="data.item.note"
                                                                              v-b-tooltip.hover>{{ data.item.name }}</span>
                                                                </template>
                                                                <template v-slot:cell(price)="data">
                                                                    <b-form-input
                                                                        :disabled="!$userIsSuperAdmin()"
                                                                        type="text"
                                                                        v-model="regionsData[data.item.id].price"
                                                                        placeholder="Enter price for region">
                                                                    </b-form-input>
                                                                </template>
                                                                <template v-slot:cell(reduction_price)="data">
                                                                    <b-form-input
                                                                        :disabled="!$userIsSuperAdmin()"
                                                                        type="text"
                                                                        v-model="regionsData[data.item.id].reduction_price"
                                                                        placeholder="Enter reduction price for region">
                                                                    </b-form-input>
                                                                </template>
                                                                <template v-slot:cell(currency)="data">
                                                                    <template
                                                                        v-if="countries && countries[data.item.currency_code]">
                                                                        {{ data.item.currency_code }}
                                                                        ({{ countries[data.item.currency_code].sign }})
                                                                    </template>
                                                                </template>
                                                            </b-table>
                                                        </BCollapse>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row mt-3">
                                                <div class="form-group col-md-6">
                                                    <b-btn type="submit" class="btn">Save</b-btn>
                                                </div>
                                            </div>

                                        </b-tab>
                                        <b-tab title="Offers" :disabled="!vehicle_stock_data">
                                            <div class="container-fluid-wide p-0" id="offer-edit-tab">
                                                <div class="row">
                                                    <div class="col-md-3 col-lg-2">
                                                        <h4>Offer Email</h4>
                                                        <b-form-group
                                                            label="Email Subject"
                                                            :label-for="getId('offer_subject')"
                                                            :state="fieldState('offer_subject')"
                                                            :invalid-feedback="invalidField('offer_subject')"
                                                        >
                                                            <b-form-input
                                                                :id="getId('offer_subject')"
                                                                type="text"
                                                                v-model="vehicleStockData.offer_subject"
                                                                :state="fieldState('offer_subject')"
                                                                :placeholder="offer_subject_placeholder">
                                                            </b-form-input>
                                                        </b-form-group>
                                                        <b-form-group
                                                            label="Offer Price"
                                                            :label-for="getId('offer_price')"
                                                            :state="fieldState('offer_price')"
                                                            :invalid-feedback="invalidField('offer_price')"
                                                        >
                                                            <div>
                                                                <a href="#!" @click.prevent="openCalcOfferPrice" class="link">Calculate</a>
                                                            </div>
                                                            <b-form-input
                                                                :id="getId('offer_price')"
                                                                type="number"
                                                                v-model="vehicleStockData.offer_price"
                                                                :state="fieldState('offer_price')"
                                                                placeholder="Offer price">
                                                            </b-form-input>
                                                        </b-form-group>
                                                        <b-form-group
                                                            label="Retail Price"
                                                            :label-for="getId('retail_price')"
                                                            :state="fieldState('retail_price')"
                                                            :invalid-feedback="invalidField('retail_price')"
                                                        >
                                                            <b-form-input
                                                                :id="getId('retail_price')"
                                                                type="number"
                                                                v-model="vehicleStockData.retail_price"
                                                                :state="fieldState('retail_price')"
                                                                placeholder="Retail price">
                                                            </b-form-input>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <label>Offer note <br/><small>Doesn't show anywhere except here, this is in offer email only</small></label>
                                                            <b-form-textarea
                                                                style="width:100%"
                                                                :id="getId('offer_note')"
                                                                :state="fieldState('offer_note')"
                                                                v-model="vehicleStockData.offer_note"
                                                            ></b-form-textarea>
                                                            <b-form-invalid-feedback
                                                                :state="fieldState('offer_note')">
                                                                {{ invalidField('offer_note') }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                        <div class="form-group">
                                                            <b-btn type="submit" class="btn mb-2">Save</b-btn>
                                                            <a @click="openSendOfferModal" class="btn">Send Offer</a>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-9 col-lg-10">
                                                        <h4>Click the images you want to include in the offer email</h4>
                                                        <small v-if="!has_offer_images" class="text-danger">
                                                            There are no images currently selected but all images have
                                                            been pre-selected to make it easier for you. Please de-select the ones you don't want.
                                                        </small>
                                                        <draggable v-model="offerEmailImages" class="row offer-images mt-4"
                                                                   @change="onOfferImagesChange">
                                                            <template v-for="(image, i) in offerEmailImages">
                                                                <div :class="offerImagesClass(image)">
                                                                    <label :for="'offer-images'+i">
                                                                        <input :id="'offer-images'+i" type="checkbox"
                                                                               :value="image.id" v-model="selectedOfferImages"
                                                                               @change="onOfferImagesChange">
                                                                        <img :src="image.url" alt="Extra Image"/>
                                                                    </label>
                                                                </div>
                                                            </template>
                                                        </draggable>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Images" :disabled="!vehicle_stock_data">
                                            <div class="row extra-images">
                                                <div class="col-md-3">
                                                    <h4>Add new images</h4>

                                                    <div class="box">
                                                        <b-form-file
                                                            :state="null"
                                                            v-model="image"
                                                            placeholder="Choose a file or drop it here..."
                                                            drop-placeholder="Drop file here..."
                                                            class="mt-1"
                                                        ></b-form-file>
                                                        <div class="mt-3">Selected file: {{
                                                                image ? image.name : ''
                                                            }}
                                                        </div>
                                                        <b-button v-if="image" @click="addImage">Add image</b-button>
                                                    </div>

                                                </div>
                                                <div class="col-md-9">
                                                    <h4>Extra images</h4>
                                                    <div class="masonry-layout">
                                                        <div class="cols">
                                                            <div v-for="(image, i) in extraActiveImages" class="box">
                                                                <div class="">
                                                                    <div class="box-header">
                                                                        <a href="#!" variant="danger"
                                                                           @click.prevent="deleteImage(image.id)">
                                                                            <icon icon=" fa-trash"
                                                                                  aria-hidden="true"></icon>
                                                                        </a>
                                                                        <a href="#!" variant="info"
                                                                           @click.prevent="updateImage(image.id)">
                                                                            <i v-if="image.active" class="fa fa-eye"
                                                                               aria-hidden="true"
                                                                               title="Make it inactive"></i>
                                                                            <i v-else class="fa fa-eye-slash"
                                                                               aria-hidden="true"
                                                                               title="Make it Active"></i>
                                                                        </a>
                                                                    </div>
                                                                    <el-image :src="image.url"
                                                                              :preview-src-list="[image.url]">
                                                                    </el-image>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h4>Inactive Images</h4>
                                                    <div class="masonry-layout">
                                                        <div class="cols">
                                                            <div v-for="(image, i) in extraInactiveImages" class="box">
                                                                <div class="">
                                                                    <div class="box-header">
                                                                        <a href="#!" variant="danger"
                                                                           @click.prevent="deleteImage(image.id)">
                                                                            <icon icon=" fa-trash"
                                                                                  aria-hidden="true"></icon>
                                                                        </a>
                                                                        <a href="#!" variant="info"
                                                                           @click.prevent="updateImage(image.id)">
                                                                            <i v-if="image.active" class="fa fa-eye"
                                                                               aria-hidden="true"></i>
                                                                            <i v-else class="fa fa-eye-slash"
                                                                               aria-hidden="true"></i>
                                                                        </a>
                                                                    </div>
                                                                    <el-image :src="image.url"
                                                                              :preview-src-list="[image.url]">
                                                                    </el-image>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-tab>

                                        <b-tab title="Global List" v-if="vehicle_stock_info && $userIsAdmin()">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h4>Global List</h4>
                                                </div>
                                            </div>
                                            <div class="row horizontal-group">
                                                <div class="col-sm-6 col-md-4">
                                                    <b-form-group
                                                                  label="Status"
                                                                  :label-for="getId('status')"
                                                                  :state="fieldState('status')"
                                                                  :invalid-feedback="invalidField('status')"
                                                    >
                                                        <b-form-select
                                                            :id="getId('status')"
                                                            :options="globalListStatusOptions"
                                                            class="form-control"
                                                            v-model="vehicleStockData.global_list_status"
                                                            :state="fieldState('status')"
                                                            placeholder="Enter status">
                                                        </b-form-select>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-sm-6 col-md-4">
                                                    <b-form-group
                                                                  label="On Behalf User"
                                                                  :label-for="getId('global_list_on_behalf_id')"
                                                                  :state="fieldState('global_list_on_behalf_id')"
                                                                  :invalid-feedback="invalidField('global_list_on_behalf_id')">
                                                        <user-selector
                                                            v-model="vehicleStockData.global_list_on_behalf_id"
                                                            placeholder="-"
                                                            :allow-empty="true"
                                                            :names-first="true"
                                                            :include-me="false"
                                                            :include-dealers="true"
                                                            :include-admins="false"
                                                            :include-reps="false"
                                                            :filter-status="null"
                                                        >
                                                        </user-selector>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                            <div class="row horizontal-group">
                                                <div class="col-sm-6 col-md-4">
                                                    <b-form-group
                                                        label="Sales Rep"
                                                        :label-for="getId('global_list_rep_id')"
                                                        :state="fieldState('global_list_rep_id')"
                                                        :invalid-feedback="invalidField('global_list_rep_id')">
                                                        <user-selector
                                                            v-model="vehicleStockData.global_list_rep_id"
                                                            placeholder="-"
                                                            :allow-empty="true"
                                                            :names-first="true"
                                                            :include-me="false"
                                                            :include-dealers="false"
                                                            :include-admins="false"
                                                        >
                                                        </user-selector>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-sm-6 col-md-4">
                                                    <b-form-group
                                                        label="Global Date"
                                                        :label-for="getId('global_list_date')"
                                                        :state="fieldState('global_list_date')"
                                                        :invalid-feedback="invalidField('global_list_date')"
                                                    >
                                                        <b-form-input
                                                            :id="getId('global_list_date')"
                                                            type="date"
                                                            v-model="vehicleStockData.global_list_date"
                                                            :state="fieldState('global_list_date')" />
                                                    </b-form-group>
                                                </div>
                                            </div>
                                            <div class="row horizontal-group">
                                                <div class="col-sm-6 col-md-4">
                                                    <b-form-group
                                                        label="Price"
                                                        :label-for="getId('global_list_display_price')"
                                                        :state="fieldState('global_list_display_price')"
                                                        :invalid-feedback="invalidField('global_list_display_price')"
                                                    >
                                                        <b-form-input
                                                            :id="getId('global_list_display_price')"
                                                            type="text"
                                                            v-model="vehicleStockData.global_list_display_price"
                                                            :state="fieldState('global_list_display_price')" />
                                                    </b-form-group>
                                                </div>
                                                <div class="col-sm-6 col-md-4">
                                                    <b-form-group
                                                        label="Retail Price"
                                                        :label-for="getId('global_list_retail')"
                                                        :state="fieldState('global_list_retail')"
                                                        :invalid-feedback="invalidField('global_list_retail')"
                                                    >
                                                        <b-form-input
                                                            :id="getId('global_list_retail')"
                                                            type="text"
                                                            v-model="vehicleStockData.global_list_retail"
                                                            :state="fieldState('global_list_retail')" />
                                                    </b-form-group>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-6 col-md-4">
                                                    <b-form-group
                                                        label="Global Note"
                                                        :label-for="getId('global_list_note')"
                                                        :state="fieldState('global_list_note')"
                                                        :invalid-feedback="invalidField('global_list_note')"
                                                    >
                                                        <b-form-textarea
                                                            :id="getId('global_list_note')"
                                                            v-model="vehicleStockData.global_list_note"
                                                            :state="fieldState('global_list_note')" />
                                                    </b-form-group>
                                                </div>
                                            </div>
                                            <div class="form-row mt-3">
                                                <div class="form-group col-md-6">
                                                    <b-btn type="submit" class="btn">Save</b-btn>
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab v-if="vehicle_stock_info && $userIsAdmin()" title="Logs">
                                            <ol>
                                                <template v-if="vehicle_stock_info.logs">
                                                    <template v-for="log in vehicle_stock_info.logs">
                                                        <li>
                                                            <span>
                                                                {{ dateToMoment(log.created_at, 'DD/MM/YYYY HH:MM') }} -
                                                            {{ log.log }}
                                                                <a v-if="log.data && log.data.changes"
                                                                   :id="`log-${log.id}`" href="#!" @click.stop.prevent>
                                                                    (view changes)
                                                                </a>
                                                            </span>
                                                            <b-tooltip v-if="log.data && log.data.changes"
                                                                       :target="`log-${log.id}`">
                                                                Data changes:
                                                                <div v-for="(change, index) in log.data.changes">
                                                                    <strong>{{ index }}</strong> {{ change.from }}
                                                                    <strong>to</strong>
                                                                    {{ change.to }}
                                                                </div>
                                                            </b-tooltip>
                                                        </li>
                                                    </template>
                                                </template>
                                                <li>{{ dateToMoment(vehicleStockData.created_at, 'DD/MM/YYYY HH:MM') }}
                                                    -
                                                    Record created
                                                </li>
                                            </ol>
                                        </b-tab>
                                        <b-tab
                                            v-if="vehicle_stock_info && vehicle_stock_info.sold && vehicle_stock_info.sold.json && vehicle_stock_info.sold.json.inspection && $userIsSuperAdmin()"
                                            title="Inspection">
                                            <Inspection :vehicle_stock_info="vehicle_stock_info"
                                                        :show_image="true"></Inspection>
                                        </b-tab>
                                        <b-tab
                                            v-if="vehicle_stock_info && vehicle_stock_info.sold && vehicle_stock_info.sold.json && vehicle_stock_info.sold.json.unshipped && $userIsSuperAdmin()"
                                            title="Inspection">
                                            <NichiboInspection :vehicle_stock_info="vehicle_stock_info"
                                                               :show_image="true"></NichiboInspection>
                                        </b-tab>
                                    </b-tabs>
                                </div>
                            </div>
                        </form>
                    </div>
                    <b-modal
                             v-model="calc_offer_yen"
                             title="Please enter your Yen buy price."
                             :hide-header-close="true"
                             :no-close-on-backdrop="true"
                             :no-close-on-esc="true"
                             @ok="calculateOfferPrice"
                    >
                        <b-form-group
                            label="Yen Price"
                            :label-for="getId('yen_buy_price')"
                        >
                            <b-form-input
                                :id="getId('yen_buy_price')"
                                type="number"
                                v-model="yen_rate"
                                placeholder="Yen buy rate">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Over sized fee"
                            :label-for="getId('over_sized_fee')"
                        >
                            <b-form-input
                                :id="getId('over_sized_fee')"
                                type="number"
                                v-model="over_sized_fee"
                                placeholder="Over sized fee">
                            </b-form-input>
                        </b-form-group>
                    </b-modal>
                </div>
            </div>
        </div>
        <vehicle-send-offer-modal :vehicle="vehicleStockData" :vehicle_id="vehicleStockData.id" v-model="sendOfferModalOpen"></vehicle-send-offer-modal>
    </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import {objLookup, numberWithCommas, getDate, getTime} from '../../util/common'
import {bidColourStyle, getOfferCost} from '../../util/bid_helper'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import UserSelector from '../Common/UserSelector'
import Inspection from './Inspection'
import NichiboInspection from './NichiboInspection'

import draggable from 'vuedraggable'
import VehicleSendOfferModal from "../VehicleSendOfferModal";

export default {
    components: {
        Inspection,
        UserSelector,
        NichiboInspection,
        draggable,
        VehicleSendOfferModal
    },
    props: [
        'vehicle_stock_data',
        'regions',
    'offer_fees',],
    mixins: [BootstrapValidation],
    data() {
        return {
            yen_rate: 0,
            over_sized_fee: 0,
            vehicle_details_open: true,
            purchase_admin_open: true,
            stock_list_open: true,
            sendOfferModalOpen: false,
            calc_offer_yen: false,
            defaultVehicleStockData: {
                api_id: null,
                lot: null,
                make: null,
                model: null,
                auction_date: null,
                auction_house: null,
                year: null,
                condition: null,
                mileage: null,
                start_price: null,
                end_price: null,
                doors: null,
                description: null,
                sale_tag: null,
                chassis: null,
                co2_emissions: null,
                grade: null,
                color: null,
                ac: 'unknown',
                seats: 4,
                tons: 1,
                stock_id: null,
                fuel_type: 'Petrol',
                equipment: '',
                regions: [],
                emissions_code: null,
                engine_capacity: null,
                sold_date: null,
                sold_price: 0,
                port: '',
                ship: '',
                estimated_departure_date: null,
                estimated_arrival_date: null,
                transmission: 'MT',
                height: 0,
                width: 0,
                length: 0,
                purchased_date: null,
                sheet_image_url: null,
                front_image_url: null,
                back_image_url: null,
                inside_image_url: null,
                sheet_image: null,
                front_image: null,
                back_image: null,
                global_list_date: null,
                global_list_status: null,
                global_list_retail: null,
                global_list_vehicle_code: null,
                global_list_on_behalf_id: null,
                inside_image: null,
                add_to_auto_mailer: 0,
                auto_mailer_sent_date: null,
                enable_auto_price_reduction: 1,
                extra_images: [],
            },
            selectedExtraImages: [],
            usersLoading: false,
            heiwaSyncLoading: false,
            regions_all: [],
            countries: window.countries,
            vehicleStockData: {},
            vehicleAuction: false,
            messages: [],
            vehicle_stock_info: this.vehicle_stock_data,
            image: null,
            seatsOptions: [...Array(50).keys()].map(function (value) {
                return {
                    value: value + 1,
                    text: value + 1,
                };
            }),
            saleTagOptions: [
                {
                    text: 'Select an option',
                    value: null
                },
                {
                    text: 'Featured',
                    value: 'Featured'
                },
                {
                    text: 'Reduced',
                    value: 'Reduced'
                },
            ],
            statusOptions: [
                {
                    text: 'Select an option',
                    value: null
                },
                {
                    text: 'Garage',
                    value: 1
                },
                {
                    text: 'Purchased',
                    value: 2
                },
                {
                    text: 'Public',
                    value: 3
                },
                {
                    text: 'Unsold',
                    value: 4
                }
            ],
            globalListStatusOptions: [
                {
                    text: "Don't show on global list",
                    value: null
                }, {
                    text: 'Trade in',
                    value: 1
                }, {
                    text: 'Out of bed',
                    value: 2
                }, {
                    text: 'On behalf',
                    value: 3
                }, {
                    text: 'Repairs',
                    value: 4
                }, {
                    text: 'Other',
                    value: 5
                }
            ],
            acOptions: ['AC', 'AAC', 'WAC', 'WAA', 'no', 'unknown'],
            currencyOptions: ['YEN', 'USD', 'AUD', 'NZD', 'GBP'],
            tonsOptions: [1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 5, 10, 15, 20, 25],
            transmissionOptions: ['MT', 'AT', 'CAT', 'CM3', 'CM4', 'CM5', 'DAT', 'FAT', 'FMT', 'MT3', 'MT4',
                'MT5', 'MT6', 'MT7'],
            fuelTypeOptions: ['Petrol', 'Diesel', 'Hybrid', 'Electric', 'PHEV', 'Diesel Hybrid'],
            regionsData: {},
            offerEmailImages: [],
            selectedOfferImages: [],
            updatedOfferImagesRequestToken: null,
            show_all_regions: false,
        }
    },
    created() {
        this.fillFormDetails();
        this.fillRegionsData();
        this.getVehicleBids();
        this.getOfferImages();
        this.yen_rate = window.currencyRate['nzd'] + window.jpyOffset;
    },
    computed: {
        regions_show(){
            if (this.show_all_regions) {
                return this.regions_all;
            } else {
                return [this.regions_all[0]]
            }
        },
        has_offer_images(){
            const extraSend = this.vehicleStockData.extra_images.filter(img => img.offer_send)
            const hasOfferImages = extraSend.length || this.vehicleStockData.front_image_offer_send
                || this.vehicleStockData.sheet_image_offer_send
                || this.vehicleStockData.inside_image_offer_send
                || this.vehicleStockData.back_image_offer_send;
            return hasOfferImages;
        },
        offer_subject_placeholder(){
            return `${this.vehicleStockData.year} ${this.vehicleStockData.make} ${this.vehicleStockData.model}` + (this.vehicleStockData.grade ? ` / ${this.vehicleStockData.grade}` : '')
        },
        extraActiveImages() {
            return this.vehicleStockData.extra_images.filter(image => image.active)
        },
        extraInactiveImages() {
            return this.vehicleStockData.extra_images.filter(image => !image.active)
        },
        auctionDateFormatted: {
            get: function () {
                if (this.vehicleStockData.auction_date) {
                    const date = moment(this.vehicleStockData.auction_date, 'YYYY-MM-DD HH:mm:ss');
                    return date.format("YYYY-MM-DDTHH:mm");
                }

                return null;
            },
            set: function (newDate) {
                this.vehicleStockData.auction_date = moment(newDate).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        soldData() {
            if (this.vehicleStockData && this.vehicleStockData.sold && this.vehicleStockData.sold.json) {
                return this.vehicleStockData.sold.json;
            }
            return {}
        },
        nextReductionDate() {
            if (this.vehicleStockData && this.vehicleStockData.auto_mailer_sent_date) {
                const sentEmailDate = moment(this.vehicleStockData.auto_mailer_sent_date, 'YYYY-MM-DD');
                const today = moment();
                // default is 28 days later
                let nextReductionDate = null;
                if (today.diff(sentEmailDate, 'days') < 7) {
                    nextReductionDate = sentEmailDate.add(7, 'days');
                } else if (today.diff(sentEmailDate, 'days') < 14) {
                    nextReductionDate = sentEmailDate.add(14, 'days');
                } else {
                    nextReductionDate = sentEmailDate.add(28, 'days');
                }
                if (nextReductionDate) {
                    return nextReductionDate.format('DD/MM/YYYY');
                }
            }
            return null;
        }
    },
    methods: {
        numberWithCommas,
        filterUnsoldReps(user){
            if (user.username === '#marc') {
                return true;
            }
            return user.role_id === 3;
        },
        openSendOfferModal(){
            const extraSend = this.vehicleStockData.extra_images.filter(img => img.offer_send)
            const hasOfferImages = extraSend.length || this.vehicleStockData.front_image_offer_send
                || this.vehicleStockData.sheet_image_offer_send
                || this.vehicleStockData.inside_image_offer_send
                || this.vehicleStockData.back_image_offer_send;
            if (!hasOfferImages) {
                this.$bvModal
                    .msgBoxConfirm('There are no stock offer images setup, are you sure you want to send an offer?')
                    .then(() => {
                        this.sendOfferModalOpen = true
                    }).catch(() => {})
            } else {
                this.sendOfferModalOpen = true
            }
        },
        onOfferImagesChange() {
            this.offerEmailImages.forEach((img, i) => {
                img.order = i + 1;
            })
            this.saveOfferImages();
        },
        saveOfferImages() {
            if (this.updatedOfferImagesRequestToken) {
                this.updatedOfferImagesRequestToken.cancel('Request cancelled for new request');
            }
            this.updatedOfferImagesRequestToken = this.axios.CancelToken.source();
            this.$store.dispatch('vehicleStock/updateOfferImages', {
                data: {
                    offer_images: this.offerEmailImages.map(img => {
                        return {
                            id: img.id,
                            order: img.order,
                            send_offer: this.selectedOfferImages.includes(img.id)
                        }
                    }),
                },
                id: this.vehicle_stock_info.id,
                cancelToken: this.updatedOfferImagesRequestToken
            })
        },
        offerImagesClass(image) {
            const classNames = ['col-md-2 extra-image-col'];
            if (this.selectedOfferImages.indexOf(image.id) !== -1) {
                classNames.push('selected')
            }
            return classNames.join(' ')
        },
        getOfferImages() {
            const images = []
            const selectedImages = [];
            if (this.vehicleStockData.images && this.vehicleStockData.images.front && this.vehicleStockData.images.front.large) {
                if (this.vehicleStockData.front_image_offer_send || !this.has_offer_images) {
                    selectedImages.push('F')
                }
                images.push({
                    id: 'F',
                    url: this.vehicleStockData.images.front.large,
                    order: this.vehicleStockData.front_image_order || 97,
                })
            }
            if (this.vehicleStockData.images && this.vehicleStockData.images.back && this.vehicleStockData.images.back.large) {
                if (this.vehicleStockData.back_image_offer_send || !this.has_offer_images) {
                    selectedImages.push('B')
                }
                images.push({
                    id: 'B',
                    url: this.vehicleStockData.images.back.large,
                    order: this.vehicleStockData.back_image_order || 98,
                })
            }
            if (this.vehicleStockData.images && this.vehicleStockData.images.interior && this.vehicleStockData.images.interior.large) {
                if (this.vehicleStockData.inside_image_offer_send || !this.has_offer_images) {
                    selectedImages.push('I')
                }
                images.push({
                    id: 'I',
                    url: this.vehicleStockData.images.interior.large,
                    order: this.vehicleStockData.inside_image_order || 99,
                })
            }
            if (this.vehicleStockData.extra_images && this.vehicleStockData.extra_images.length) {
                this.vehicleStockData.extra_images.forEach(img => {
                    if (img.offer_send || !this.has_offer_images) {
                        selectedImages.push(img.id)
                    }
                    images.push({
                        id: img.id,
                        url: img.url,
                        order: img.sort_order || 50,
                    })
                })
            }
            if (this.vehicleStockData.images && this.vehicleStockData.images.sheet && this.vehicleStockData.images.sheet.large) {
                if (this.vehicleStockData.sheet_image_offer_send || !this.has_offer_images) {
                    selectedImages.push('S')
                }
                images.push({
                    id: 'S',
                    url: this.vehicleStockData.images.sheet.large,
                    order: this.vehicleStockData.sheet_image_order || 100,
                })
            }
            //sort by order
            images.sort((a, b) => {
                //put selected ones first
                const sel_a = selectedImages.includes(a.id) ? 0 : 1;
                const sel_b = selectedImages.includes(b.id) ? 0 : 1;
                return sel_a - sel_b || a.order - b.order;
            })

            this.offerEmailImages = images

            this.selectedOfferImages = selectedImages
        },
        async syncVehicleWithHewia() {
            try {
                this.heiwaSyncLoading = true;
                const {vehicle_stock} = await this.$store.dispatch('vehicleStock/syncWithHewia', this.vehicleStockData.id)
                this.vehicleStockData = vehicle_stock
                this.$message({
                    message: 'Vehicle synced successfully',
                    type: 'success'
                });
                this.heiwaSyncLoading = false;
            } catch (e) {
                this.heiwaSyncLoading = false;
                this.$message({
                    message: 'Vehicle could not be synced this time, please try later.',
                    type: 'error'
                });
            }
        },
        bumpBidDisplay(number) {
            if (!number) {
                return '';
            }
            let k = number / 1000;
            return `Bump ${k}k`
        },
        canEditSoldPrice() {

            if (this.$userIsSuperAdmin()) {
                return true;
            } else {
                if (this.vehicleStockData.is_garage && this.vehicleStockData.user_id === this.loggedInUser.id) {
                    return true
                }
            }
            return false;
        },
        async copyImage(type, image_url) {
            try {
                let url = this.$laravelRoute('vehicle-stock.add-image-url', this.vehicleStockData.id);
                let res = await this.axios.post(url, {url: image_url.replace(' ', '%20'), type});
                if (res && res.data && res.data.vehicle_stock) {
                    if (type === 'extra') {
                        this.vehicleStockData.extra_images = res.data.vehicle_stock.extra_images
                    } else {

                        this.vehicleStockData[`${type}_image_url`] = res.data.vehicle_stock[`${type}_image_url`]
                    }
                }
            } catch (e) {
                console.warn('Exception in copyImage', e)
            }

        },
        async imageUpload(type) {
            // when editing
            if (this.vehicleStockData.id && this.vehicleStockData[`${type}_image`]) {
                let data = new FormData();
                data.append('image', this.vehicleStockData[`${type}_image`]);
                data.append('type', type);
                let url = this.$laravelRoute('vehicle-stock.add-main-image', this.vehicleStockData.id);
                let res = await this.axios.post(url, data);
                if (res && res.data && res.data.vehicle_stock) {
                    this.vehicleStockData[`${type}_image`] = null
                    this.vehicleStockData[`${type}_image_url`] = res.data.vehicle_stock[`${type}_image_url`]
                }
            }
        },
        async getVehicleBids() {
            if (this.vehicleStockData && !this.vehicleStockData.bid_id && this.vehicleStockData.sold && this.vehicleStockData.sold.import_status === 1) {
                if (this.vehicle_stock_info.api_id) {
                    let url = this.$laravelRoute('vehicle-stock.check-bids', this.vehicleStockData.id);
                    let res = await this.axios.get(url);
                    if (res.data && res.data.vehicle) {
                        this.vehicleAuction = res.data.vehicle;
                        this.bid_selection_open = true;
                    }
                }
            }
        },
        onUserChange() {
            if (this.regionsData) {
                for (let i in this.regionsData) {
                    this.regionsData[i].is_active = false;
                }
            }
        },
        isJsonObject(key, value) {
            if (typeof value === 'object') {
                return !Array.isArray(value)
            }
            return false;
        },
        showInspectionValue(key, bool) {
            let value = objLookup(this.vehicle_stock_info, `sold.json.inspection.${key}`)
            if (typeof value === 'undefined') {
                return ''
            }
            if (value === 'NO' || value === 'YES') {
                let icon = value === 'YES' ? 'fa-check text-success' : 'fa-times text-danger'
                return `<i class="fa ${icon}"></i>`
            } else if (bool) {
                return value ? value : '?'
            }
            return value
        },
        showInspectionList(key) {
            let value = objLookup(this.vehicle_stock_info, `sold.json.inspection.${key}`)
            if (typeof value === 'undefined' || !value) {
                return false
            }
            if (value.indexOf('|') !== -1) {
                return value.split('|')
            }
            return value ? [value] : false
        },
        async selectBid(bid) {
            let url = this.$laravelRoute('vehicle-stock.set-bid', this.vehicle_stock_info.id);
            let res = await this.axios.post(url, {
                bid_id: bid.id
            });
            if (res.data && res.data.stock) {
                this.vehicleStockData.staff_note = res.data.stock.staff_note;
                this.vehicleStockData.sold = res.data.stock.sold;
                this.vehicleStockData.bid_id = res.data.stock.bid_id;
            }
            this.bid_selection_open = false;
        },
        bidColourStyle(bid) {
            return bidColourStyle(bid);
        },
        formatNumber(val) {
            return numberWithCommas(val);
        },
        getDate(data) {
            return getDate(data)
        },
        getTime(data) {
            return getTime(data)
        },
        objLookup(obj, key) {
            return objLookup(obj, key);
        },
        openCalcOfferPrice() {
            if (!this.vehicleStockData.sold_price || !this.vehicleStockData.currency) {
                this.$bvModal.msgBoxOk('Please enter a "Final price" first', {title: 'Error'})
                return;
            }
            const currency = this.vehicleStockData.currency.toLowerCase();
            if (currency !== 'yen') {
                this.$bvModal.msgBoxOk('Cannot calculate price, the final price is not in Yen', {title: 'Error'})
                return;
            }

            this.calc_offer_yen = true
        },
        calculateOfferPrice(){
            let base_price = 0;
            const fees = this.offer_fees;
            const ex_rate = parseFloat(this.yen_rate)
            const yen = parseInt(this.vehicleStockData.sold_price);
            base_price = getOfferCost(yen, fees, ex_rate)
            this.vehicleStockData.offer_price = base_price + parseFloat(this.over_sized_fee);
        },
        getId(...args) {
            let makeSafeForCSS = (name) => {
                if (typeof name !== 'string') {
                    name = name.toString()
                }
                return name.replace(/[^a-z0-9]/g, (s) => {
                    var c = s.charCodeAt(0);
                    if (c == 32) return '-';
                    if (c >= 65 && c <= 90) return '_' + s.toLowerCase();
                    return '__' + ('000' + c.toString(16)).slice(-4);
                });
            }
            let arr = []
            args.forEach(v => {
                arr.push(makeSafeForCSS(v))
            })
            return arr.join('_');
        },
        getRegionsForSend() {
            let res = {};
            for (let key in this.regionsData) {
                if (this.regionsData.hasOwnProperty(key) &&
                    (this.regionsData[key].is_active || this.regionsData[key].price > 0)) {
                    res[key] = this.regionsData[key];
                }
            }

            return res;
        },
        onStatusChange() {
            if (this.vehicleStockData.status === 3) {
                // add confirmation modal
                this.$bvModal.msgBoxOk('Ensure you get the offer price from the offers tab.', {
                    title: 'Alert'
                })
            }
        },
        fillRegionsData() {
            let ids = [];
            this.regions_all = [];
            this.vehicleStockData.regions.forEach((region) => {
                ids.push(region.id);
                this.regionsData[region.id] = {is_active: !!region.pivot.is_active, price: region.pivot.price, reduction_price: region.pivot.reduction_price}
            });
            this.regions.forEach((region) => {
                if (region.enabled || ids.indexOf(region.id) !== -1) {
                    this.regions_all.push(region);
                }
                if (region.enabled && !this.regionsData[region.id]) {
                    this.regionsData[region.id] = {is_active: false, price: null, reduction_price: null};
                }
            });
        },
        fillFormDetails() {
            if (this.vehicle_stock_info) {
                this.vehicleStockData = this.vehicle_stock_info;
            } else {
                this.vehicleStockData = Object.assign({}, this.defaultVehicleStockData);
            }
            if (this.vehicleStockData.extra_images) {
                this.vehicleStockData.extra_images.forEach(v => {
                    if (v.active) {
                        this.selectedExtraImages.push(v.id)
                    }
                })
            }
        },
        addImage() {
            this.messages = [];
            this.$store.dispatch('vehicleStock/addVehicleStockImage', {
                image: this.image,
                vehicle_stock_id: this.vehicle_stock_info.id
            }).then(response => {
                if (response) {
                    this.messages.push({type: 'success', message: response.message});
                    this.vehicleStockData.extra_images = response.images;
                    this.image = null;
                    this.errors = [];
                } else {
                    this.messages.push({type: 'danger', message: 'Unable to add image.'});
                }
            }).catch(error => {
                this.messages.push({type: 'danger', message: error.message});
                this.errors = error.errors;
            });
        },
        setActiveImages(image) {
            this.$nextTick(async () => {
                let data = {};
                this.vehicleStockData.extra_images.forEach(img => {
                    data[img.id] = this.selectedExtraImages.includes(img.id) ? 1 : 0
                })
                let res = await this.$store.dispatch('vehicleStock/setActiveImages', data)
            })
        },
        deleteImage(id) {
            this.messages = [];
            this.$store.dispatch('vehicleStock/deleteVehicleStockImage', {
                id: id,
                vehicle_stock_id: this.vehicle_stock_info.id
            }).then(response => {
                if (response) {
                    this.messages.push({type: 'success', message: response.message});
                    this.vehicleStockData.extra_images = response.images;
                    this.image = null;
                    this.errors = [];
                } else {
                    this.messages.push({type: 'danger', message: 'Unable to delete image.'});
                }
            }).catch(error => {
                this.messages.push({type: 'danger', message: error.message});
                this.errors = error.errors;
            });
        },
        updateImage(id) {
            this.messages = [];
            this.$store.dispatch('vehicleStock/toggleActiveVehicleStockImage', {
                id: id,
                vehicle_stock_id: this.vehicle_stock_info.id
            }).then(response => {
                if (response) {
                    this.vehicleStockData.extra_images = response.images;
                    this.image = null;
                    this.errors = [];
                } else {
                    this.messages.push({type: 'danger', message: 'Unable to update the image.'});
                }
            }).catch(error => {
                this.messages.push({type: 'danger', message: error.message});
                this.errors = error.errors;
            });
        },
        selectAllImages() {
            this.selectedExtraImages = JSON.parse(JSON.stringify(this.soldData.extraphotos));
        },
        onSubmit() {
            this.messages = [];
            if (this.vehicle_stock_info) {
                let data = this.vehicleStockData;
                data.regions = this.getRegionsForSend();
                this.$store.dispatch('vehicleStock/updateVehicleStock', {
                    data: data,
                    id: this.vehicle_stock_info.id
                }).then(response => {
                    if (response) {
                        this.messages.push({type: 'success', message: 'Vehicle stock updated.'});
                        this.vehicleStockData = response;
                        this.vehicle_stock_info = response;
                        this.fillRegionsData();
                        this.errors = [];
                    } else {
                        this.messages.push({type: 'danger', message: 'Unable to update.'});
                    }
                }).catch(error => {
                    this.messages.push({type: 'danger', message: error.response.data.message});
                    this.errors = error.response.data.errors;

                });
            } else {
                let data = this.vehicleStockData;
                data.regions = this.getRegionsForSend();

                this.$store.dispatch('vehicleStock/storeVehicleStock', {
                    data: data,
                }).then(response => {
                    if (response && response.id) {
                        window.location = `/vehicle-stock/${response.id}/edit`
                    } else {
                        this.messages.push({type: 'danger', message: 'Unable to create.'});
                    }
                }).catch(error => {
                    console.warn('create err', error);
                    this.messages.push({type: 'danger', message: error.message});
                    this.errors = error.errors;
                });
            }
        },
    }
}
</script>

<style scoped lang="scss">
@import "./resources/sass/mixins";
@import "./resources/sass/variables";

.offer-images {
    .extra-image-col {
        opacity: 0.5;

        img {
            border: 2px solid white;
        }

        &.selected {
            opacity: 1;

            img {
                border: 2px solid $blue;
            }
        }
    }
}
#offer-edit-tab{
    input{
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/CreatePage.vue